// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c1qa","buttons":"styles_buttons__25NvG"};